import Link from 'next/link';

import { STATES } from '@/data/states';

import * as styles from './index.module.scss';

const StatesList = () => (
  <div className={`${styles['states-list-container']}`}>
    <div className="container">
      <h3>States</h3>
      <ul className={styles['state-links-container']}>
        {Object.values(STATES).map((state) => {
          const stateId = state.abbreviation.toLowerCase();
          return (
            <li key={stateId}>
              <Link href={`/us/${stateId}`}>{state.label} Pros</Link>
            </li>
          );
        })}
      </ul>
    </div>
  </div>
);

export default StatesList;
